/**
 * Created by andrey on 01.12.2025
 */

const CorruptedWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const styles = cleverapps.styles.CorruptedWindow;

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SYSTEM.SYNC_CORRUPTED_WINDOW);

        const text = cleverapps.UI.generateOnlyText(Messages.get("CorruptedWindow.Text"), cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);

        const content = cleverapps.UI.wrapWithPadding(text, styles.padding);

        this._super({
            content,
            title: Messages.get("CorruptedWindow.Title"),
            name: "corruptedwindow",
            button: {
                text: Messages.get("OK")
            }
        });
    }
});

cleverapps.styles.CorruptedWindow = {
    padding: {
        x: 20,
        y: 80
    },
    
    text: {
        width: 600
    }
};

if (cleverapps.config.orientation === "horizontal") {
    cleverapps.styles.CorruptedWindow.text.width *= 1.5;
}